import { z } from 'zod';
import { paymentStrategySchema } from './invoices.js';
export const vendorPaymentSettingsSchema = z.object({
    paymentStrategy: paymentStrategySchema,
    paidExternallyRecurring: z.boolean().default(false),
    payabliMethodOnFile: z.boolean().default(false),
});
export function normalizeVendorName(name) {
    return name.trim().toLowerCase();
}
export const MAX_VENDOR_NAME_LENGTH = 255;
export const vendorRemitAddressSchema = z.object({
    street: z.string().trim().min(1).max(255).describe('The street line of the address.'),
    city: z.string().trim().min(1).max(100).describe('The city.'),
    state: z
        .string()
        .trim()
        .toUpperCase()
        .regex(/^[A-Z]{2}$/, 'Use the two-letter state code, for example NY')
        .describe('The two-letter state code, such as NY.'),
    zipCode: z
        .string()
        .trim()
        .regex(/^\d{5}(-\d{4})?$/, 'Use a 5-digit ZIP code, or ZIP+4')
        .describe('A 5-digit ZIP code, or ZIP+4.'),
});
const COUNTRY_SUFFIX = /,\s*(?:USA|US|U\.S\.A?\.?|United States(?: of America)?)$/i;
const ADDRESS_LINE = /^(.+),\s*([^,]+?),?\s+([A-Za-z]{2}),?\s+(\d{5}(?:-\d{4})?)$/;
export function parseVendorAddressLine(text) {
    const line = text
        .split(/\r?\n/)
        .map((part) => part.trim())
        .filter(Boolean)
        .join(', ')
        .replace(/\s+/g, ' ')
        .replace(COUNTRY_SUFFIX, '');
    const [, street, city, state, zipCode] = ADDRESS_LINE.exec(line) ?? [];
    const parsed = vendorRemitAddressSchema.safeParse({ street, city, state, zipCode });
    return parsed.success ? parsed.data : null;
}
export function formatVendorAddressLine(address) {
    return `${address.street}, ${address.city}, ${address.state} ${address.zipCode}`;
}
//# sourceMappingURL=vendors.js.map